<template>
    <nav :class="['navbar navbar-expand-md navbar-light', {'is-sticky': isSticky}]">
        <router-link class="navbar-brand" to="/">
            <img src="../../assets/img/jill_icon_n.png" alt="Logo">
        </router-link>

        <div 
            class="navbar-toggler" 
            @click="active = !active" :aria-pressed="active ? 'true' : 'false'"
            v-bind:class="{ 'active': button_active_state }"
            v-on:click="button_active_state = !button_active_state"
        >
            <i class='bx bx-menu'></i>
            <i class='bx bx-x'></i>
        </div>

        <div class="collapse navbar-collapse" :class="{ toggler: active }">
            <ul class="navbar-nav">
                <li class="nav-item">
                    <a class="nav-link" @click="scroll('home')" href="/">Inicio</a>
                </li>  
                
                <li class="nav-item">
                    <a class="nav-link" @click="scroll('service')" href="/#service">Servicio Técnico</a>
                </li>

                <li class="nav-item">
                    <a class="nav-link" @click="scroll('service-multiple')" href="/#service-multiple">Tintas y Consumibles</a>
                </li>
                <li class="nav-item">
                    <a class="nav-link" @click="scroll('contact-strip')" href="/#contact-strip">Contáctanos</a>
                </li>
                <li class="nav-item">
                    <a class="nav-link" href="/sobrenosotros">Sobre Nosotros</a>
                </li>
            </ul>
        </div>

    </nav>
</template>

<script>
export default {
    name: 'NavbarOne',
    data(){
        return {
            isSticky: false,
            active: false,
            button_active_state: false
        }
    },
    mounted(){
        const that = this
        window.addEventListener('scroll', () => {
            let scrollPos = window.scrollY
            if(scrollPos >= 100){
                that.isSticky = true
            } else {
                that.isSticky = false
            }
        })
    },
    methods: {
        scroll(refName) {
            const element = document.getElementById(refName);
            element.scrollIntoView({behavior: "smooth"})
        }
    }
}
</script>